import React from 'react';
import {Input} from "antd";
import {formatCurrency} from "../../../format/Money";

const InputDecimal = props => {
    const { setFieldValue,form,name} = props;

    const handleChange = (e) => {
        const inputValue = e.target.value;

        if (/^[-]?[\d.,]*$/.test(inputValue)) {

            const hasComma = inputValue.split(",");
            if (hasComma.length > 2) return;

            const formattedValue = formatCurrency(inputValue,true);

            if(setFieldValue) {
                setFieldValue(formattedValue)
            }
            else if(form && name) {
                form.setFieldValue(name,formattedValue)
            }
        }

    }

    return (
        <Input
            {...props}
            onChange={handleChange}
            style={{
                textAlign: props.textAlign || 'left',
                width: '100%'
            }}
        />
    );
};


export default InputDecimal;
